import * as React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';

import { IStore } from '../../modules/root-reducer';

interface IProtectedRouteProps extends RouteProps {
  loggedIn: boolean;
}

export class ProtectedRoute extends Route<IProtectedRouteProps> {
  render(): JSX.Element {
    if (!this.props.loggedIn) {
      const renderComponent = () => <Redirect to={{ pathname: '/login' }} />;
      return <Route {...this.props} component={renderComponent} />;
    } else {
      return <Route {...this.props} />;
    }
  }
}

const mapStateToProps = (state: IStore) => ({
  loggedIn: state.loginReducer.loggedIn
});

export default connect(mapStateToProps)(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/common/routes/protected-route.tsx